<template>
  <div class="mb-16">
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-img
        v-if="about && about.image_pc_aboutus"
        :src="about.image_pc_aboutus"
      ></v-img>
      <v-img v-else src="../assets/images/about/banner-dt.png"></v-img>
    </div>
    <div v-else>
      <v-img
        v-if="about && about.image_mb_aboutus"
        :src="about.image_mb_aboutus"
      ></v-img>
      <v-img v-else src="../assets/images/about/banner-mb.png"></v-img>
    </div>

    <v-container class="mw-1150">
      <Topic ref="course" eng="Objective" thai="วัตถุประสงค์"></Topic>
      <div class="mt-6" v-html="about.objective"></div>
      
      <Topic ref="course" eng="Background" thai="ที่มาของโครงการ"></Topic>
      <div class="mt-6" v-html="about.background"></div>

      <Topic class="my-12" eng="Target Audience" thai="กลุ่มเป้าหมาย"></Topic>
      <div>
        <v-img v-if="about.image_target" :src="about.image_target"></v-img>
        <v-img v-else src="../assets/images/about/image1.png"></v-img>
      </div>

      <Topic class="mt-12" eng="Board" thai="คณะทำงาน"></Topic>

      <div>
        <v-img
          v-if="about && about.image_working_group"
          :src="about.image_working_group"
        ></v-img>

        <v-img v-else src="../assets/images/about/image-dt.png"></v-img>
      </div>
    </v-container>
  </div>
</template>

<script>
import Topic from "../components/Topic.vue";
import AboutTarget from "../components/About/AboutTarget.vue";
import AboutTargetDetail from "../components/About/AboutTargetDetail.vue";
import axios from "axios";

import { domain } from "../util/Constant";
export default {
  components: {
    Topic,
    // AboutTarget, AboutTargetDetail
  },
  data() {
    return {
      about: null,
      objective:
        "<p><strong>วัตถุประสงค์ที่ 1</strong><br />พัฒนาศักยภาพ ระบบให้คำปรึกษาและสนับสนุน การทำงานของผู้ปฏิบัติงานในศูนย์พึ่งได้ (OSCC) และบุคลากรที่เกี่ยวข้องในสังกัดกระทรวง สาธารณสุข และ เครือข่ายผู้ปฏิบัติงานด้านเด็ก ครอบครัว และการคุ้มครองเด็ก<br /><br /><strong>วัตถุประสงค์ที่ 2</strong><br />พัฒนาชุมชนนักปฏิบัติเป็นพื้นที่สื่อสาร และเครือข่ายแลกเปลี่ยนเรียนรู้การทำงาน ทั้งในด้านองค์ความรู้ ประสบการณ์ในการจัด การปัญหาของผู้<br />ปฏิบัติงานด้านเด็กและครอบครัว<br /><br /><strong>วัตถุประสงค์ที่ 3</strong><br />พัฒนาพื้นที่ต้นแบบด้านการดูแลคุ้มครองเด็ก ให้มีศักยภาพ และสามารถพัฒนาเป็นแหล่งศึกษาดูงานในงานเฉพาะด้าน<br /><br /><strong>วัตถุประสงค์ที่ 4</strong><br />เพื่อจัดทำข้อเสนอในการพัฒนารูปแบบและกลไกที่เหมาะสมทั้งในระบบปฏิบัติการ และระบบการให้คำปรึกษา และพัฒนาศักยภาพผู้ปฏิบัติงานต่อ กระทรวงสาธารณสุข และหน่วยงานที่เกี่ยวข้อง เพื่อผลักดันเป็นระบบปกติต่อไป</p>",
      targetAudience: [
        {
          image: require("@/assets/mock/about-icon-1.png"),
          title: "ระบบงาน",
          color: "#4090FF",
          detail_color: "#6DCDEC",
          detail: [
            { text: "การแพทย์ การสาธารณสุข" },
            { text: "การสังคมสงเคราะห์/สวัสดิการสังคม" },
            { text: "กระบวนการยุติธรรม" },
            { text: "การช่วยเหลือและฟื้นฟูพัฒนาเด็กระยะยาว" },
          ],
        },
        {
          image: require("@/assets/mock/about-icon-2.png"),
          title: "หน่วยงานให้บริการ",
          color: "#6E49EC",
          detail_color: "#C9B9FD",
          detail: [
            { text: "รพ.สต./รพช./รพท./รพศ." },
            { text: "บ้านพักเด็กและครอบครัวเทศบาล อบต." },
            { text: "สถานีตำรวจภูธร/นครบาล" },
            { text: "ผู้นำชุมชน(กำนัน,ผู้ใหญ่บ้าน) อปท.(อบต./เทศบาล)" },
          ],
        },
        {
          image: require("@/assets/mock/about-icon-3.png"),
          title: "ทีมบุคคลากร",
          color: "#80C843",
          detail_color: "#ADEE74",
          detail: [
            {
              text: "ทีมสหวิชาชีพในรพ. (แพทย์สาขาต่างๆ /พยาบาล/พยาบาลจิตเวช /นักสังคมสงเคราะห์ /นักจิตวิทยาฯลฯ)/อสม",
            },
            { text: "นักสังคมสงเคราะห์/พนักงานเจ้าหน้าที่คุ้มครองเด็ก" },
            { text: "พนักงานสอบสวน (หญิง/ชาย)" },
            { text: "นักสังคมสงเคราะห์ /นักพัฒนาชุมชน /อาสาสมัครในชุมชน" },
          ],
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // get axios url and get data
    getData() {
      axios
        .get(domain + "/about")
        .then((response) => {
          this.about = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.target__icon {
  background: #4090ff;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.25);
  width: 107px;
  height: 107px;
  border-radius: 100%;
}
</style>
